// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"89f811c6","455":"ce8a31ae"}[chunkId] + ".chunk.js";
};